import { render, staticRenderFns } from "./orderPrepayment.vue?vue&type=template&id=12092dae&scoped=true"
import script from "./orderPrepayment.vue?vue&type=script&lang=js"
export * from "./orderPrepayment.vue?vue&type=script&lang=js"
import style0 from "./orderPrepayment.vue?vue&type=style&index=0&id=12092dae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12092dae",
  null
  
)

export default component.exports